import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Title from './../../../common/TitlePage';


const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        position: 'relative',
        padding: '82px 0px',
    },
    grid: {
        width: '51%',
        margin: 'auto',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        minWidth: '330px',

        [theme.breakpoints.down('sm')]: {
            width: '80%',
            fontSize: theme.fontSize.small,
            minWidth: '92%',
        },
    },
    Shape: {
        position: 'absolute',
        left: 0,
        bottom: 0,
        [theme.breakpoints.down('sm')]: {
            display: 'none'
        },
        '& > .Rectangle1': {
            width: 150,
            height: 75,
            backgroundColor: '#F4F4F4',
        },
        '& > .Rectangle2': {
            width: 100,
            height: 75,
            marginTop: 20,
            backgroundColor: '#F4F4F4',
        },
    },
    title: {
        fontSize: theme.fontSize.xLarge,
        [theme.breakpoints.down('sm')]: {
            fontSize: theme.fontSize.medium
        },
    },
    desc: {
        margin: '44px 0px 0px 0px',
        fontSize: theme.fontSize.regular,
        lineHeight: "35px",
        [theme.breakpoints.down('sm')]: {
            fontSize: theme.fontSize.small
        },
    }
}))


export default function Index() {

    const classes = useStyles();

    const state = {
        title: 'چرا در بورس سرمایه گذاری کنیم؟  ',
        desc: 'یکی از دلایل اصلی سرمایه گذاری افراد در بازار بورس، حفظ سرمایه در مقابل موج‌های تورمی و در مرحله بعدی، کسب بازدهی بالا است. شاید زمانی سپرده‌ گذاری در بانک و دریافت سود ماهیانه توجیه پذیر بود، اما در شرایط اقتصادی سال‌های اخیر این گزینه سرمایه گذاری به هیچ عنوان عملکرد معقولی نداشته است. بنابراین اگر دانش مالی کافی و قدرت ریسک پذیری بالایی هم دارید، بازار سهام بهترین محل سرمایه گذاری با ابزار متنوع است.',
        btn: 'افتتاح حساب غیر حضوری',
    }

    return (
        <div className={classes['root']}>
            {/* <div className={classes['Shape']}>
                <div className={'Rectangle1'}></div>
                <div className={'Rectangle2'}></div>
            </div> */}
            <div className={classes['grid']}>
                <Title position={'bottomCenter'} padding={'20px'}>
                    <span className={classes['title']} >{state.title}</span>
                </Title>
                <p className={classes['desc']}>{state.desc}</p>
            </div>
        </div>
    )
}
